import { Box, Input, Typography } from '@material-ui/core'
import React, { useEffect, useState } from 'react'
import { PipelineStepButton } from './PipelineStepButton'
import { SelectComponent } from '../../../common/Select'
import { StatusLineComponent } from '../../../common/StatusLine'
import StyleIcon from '@material-ui/icons/Style'
import { ButtonComponent } from '../../../common/Button'
import { StatusLine, Selector } from '../../../../types'

export function InstanceComponent(props: {
  disabled: boolean
  onInstanceChange: Function
  onStartDeployment: Function
  instance: string
  pipelineSteps: Selector[]
  deploymentTag: string
  deploymentStatus: StatusLine
  instances: string[]
}) {
  const { onInstanceChange, onStartDeployment, instance, pipelineSteps, deploymentTag, disabled, instances, deploymentStatus } = props
  const [display, setDisplay] = useState(false)

  useEffect(() => {
    if (deploymentTag && pipelineSteps.length > 0 && instance && instances.length > 0) {
      setDisplay(true)
    }
  }, [deploymentTag, pipelineSteps, instance, instances])

  if (display) {
    return (
      <React.Fragment>
        <Box className='upperBox'>
          <Box className='flexCenter'>
            <Typography variant='body1' className='margin-right'>
              <b>Instanz: </b>
            </Typography>
            <SelectComponent disabled={disabled} callback={onInstanceChange} value={instance} items={instances} />
            <Typography className='margin-right' variant='body1'>
              <b>Version: </b>
            </Typography>
            <Input disabled={disabled} className='margin-right' value={deploymentTag} />
          </Box>
          <Box className='flexCenter'>
            {pipelineSteps.map((selector, index) => (
              <PipelineStepButton key={index} disabled={disabled} callback={onStartDeployment} selector={selector} />
            ))}
            <ButtonComponent callback={onStartDeployment} disabled={disabled} icon={<StyleIcon />} text={'Tags setzen'} />
          </Box>
        </Box>
        <Box className='statusLine'>
          <StatusLineComponent status={deploymentStatus} />
        </Box>
      </React.Fragment>
    )
  }
  return null
}
